import { Http } from './';
import { Config } from '../types';

const get = () => Http.get<Config>('conf/options.json');

export default get;
